<template>
  <v-container class="flex" fill-height>    
    <v-layout row align-center justify-space-around wrap>           
      <v-flex xl4 lg6 md8 sm10 xs11 class="inline-block">         
        <v-alert v-if="messageAccueilVisible" :value="originalMsgAccueil.message && originalMsgAccueil.message.length > 0" type="info" class="mb-4" v-html="messageAccueilHtml"  />
        <v-container @keydown.enter="submit" class="text-xs-center grey lighten-4">                              
          <v-card flat>
            <v-card-title primary-title>              
              <h4 v-if="!forgotpass">{{$t('Login.Login')}}</h4>              
              <h4 v-else>{{$t('Login.ForgotPassword')}}</h4>              
            </v-card-title>
            <v-form class="mx-2">
              <v-text-field class="!pr-10" v-model="UserName" ref="UserName" browser-autocomplete="username" prepend-icon="mdi-account" name="UserName" :label="$t('Login.Username')" ></v-text-field>
              <v-text-field v-show="!forgotpass" v-model="Password" ref="Password" :append-outer-icon="showPassword?'mdi-eye-off':'mdi-eye'"  @click:append-outer="showPassword = !showPassword" browser-autocomplete="current-password" prepend-icon="mdi-lock" name="Password" :label="$t('Login.Password')" :type="showPassword?'text':'password'" ></v-text-field>
              <v-card-actions>
                <v-btn :disabled="loading" :loading="loading" @click="submit" color="primary" large block >{{forgotpass?$t('Login.SendRequest'):$t('Login.LoginAction')}}</v-btn>
              </v-card-actions>                
              {{authStatus.length > 0? $t(`${authStatus}`):''}}  
              <v-btn  small style="text-transform:none" flat @click="forgotpassword" color="primary" block >{{forgotpass?$t('Login.CancelRequest'):$t('Login.ForgotPassword')}}</v-btn>                                   
            </v-form>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AlqForgottenPass } from '@/models/query/AlqForgottenPass'
import { AlqIdentityToken } from '@/models/query/AlqIdentityToken'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import { MsgAccueil } from '@/models/datapool/MsgAccueil'

@Component({
  name: 'Login',  
})
export default class Login extends Vue {
  
  UserName = ''
  Password = ''
  Mail = ''
  dirtyEmail = false
  dirtyPwd = false
  forgotpass = false
  loading = false
  showPassword = false
  
  get authStatus() {
    switch(this.$store.myGetters.authStatus){
      case "AuthenticationProgress":
        return this.$t('Login.AuthenticationProgress')
      case "AuthenticationSuccess":
        return this.$t('Login.AuthenticationSuccess')
      case "AuthenticationError":
        return this.$t('Login.AuthenticationError')     
      case "PassForgottenSuccess":
        return this.$t('Login.PassForgottenSuccess')  
      case "PassForgottenProgress":
        return this.$t('Login.PassForgottenProgress')  
      case "PassForgottenError":
        return this.$t('Login.PassForgottenError') 
      default:
        return ''        
    }
  }

  get redirectPath(){
      return this.$store.myGetters.redirectPath
  }

  get originalMsgAccueil(){
    return MsgAccueil.createMsgAccueil(this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.msgAccueil']))
  }

  get  messageAccueilHtml() {
    return  this.originalMsgAccueil.message.trimEnd().replace("\n","<br/>") 
  }
  
  get messageAccueilVisible(){
    return MsgAccueil.isVisible(this.originalMsgAccueil)
  }
  
  beforeDestroy() {

  }
  
  @Watch("dirtyEmail")
  dirtyEmailChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.UserName.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyPwd")
  dirtyPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.Password.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  mounted(){
    this.hackToSolveAutoFillIssue()  
    this.$store.myActions.DATAPOOL_MSG_ACCUEIL_REQUEST()
    this.$store.myActions.AUTH_RESET_STATUS()
    this.$vuetify.theme.primary = '#4066aa'
    this.$vuetify.theme.secondary = '#ec7404'    
  }

  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="Password"]:-webkit-autofill')
      }
    }, 100)
  }
    
  submit() {     
    this.loading = true   
    if(this.forgotpass){      
      const data = new AlqForgottenPass()
      data.userLogin = this.UserName
      this.$store.myActions.AUTH_PASSWORD_REQUEST(data).finally(() => {
        this.loading = false
      })
    }
    else{
      const {UserName, Password} = this          
      this.$store.myActions.AUTH_REQUEST(new AlqIdentityToken({ login:UserName,pass:Password})).then(() => {                            
        this.$router.push(this.redirectPath)
      }).finally(() => {
        this.loading = false
      })
    }
  }  

  forgotpassword() {
    this.$store.myActions.AUTH_RESET_STATUS()
    this.forgotpass = !this.forgotpass
  }
}
</script>

<style>
</style>